import { astarZkEVM as viemAstarZkEVM } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const astarZkEVM = {
  displayName: 'Astar zkEVM',
  runtime: 'evm',
  viemChain: viemAstarZkEVM,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'astar-zkevm' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
